import { useUpdateOrgDetails } from '../hooks/useUpdateOrgDetails';
import { Header } from '../types';

interface SaveHeaderParams {
  selectedHeader: Header;
  updatedHeaders: Header[];
}

export const useSaveHeaderService = () => {
  const { updateOrgDetails, loading, error } = useUpdateOrgDetails();

  const saveHeader = async ({ selectedHeader, updatedHeaders }: SaveHeaderParams) => {
    if (!selectedHeader) {
      throw new Error('Please select a header first');
    }

    const headerToUpdate = updatedHeaders.find(h => h.requestNumber === selectedHeader.requestNumber) || selectedHeader;
    
    if (!headerToUpdate.toSite) {
      throw new Error('Please select a To Site before saving');
    }

    const result = await updateOrgDetails({
      p_return_header_id: selectedHeader.requestNumber,
      p_whid: headerToUpdate.toSite
    });

    if (!result || !result.success) {
      throw new Error(result?.return_message || 'Unknown error');
    }

    return {
      success: true,
      message: result.return_message,
      updatedToSite: headerToUpdate.toSite
    };
  };

  return {
    saveHeader,
    loading,
    error
  };
};